<div class="spinner-container" role="status" aria-label="Signing in">
  <tds-spinner size="lg" variant="standard"></tds-spinner>
</div>
